<template lang="pug">
    .member.full-height-error.not-valid(v-if="!enabled")
        Error(:message="null" :code="403")
    .member.full-height-error.not-allowed(v-else-if="pathNotValid")
        Error(:message="$t('URL Not Valid')")
    .member.full-height-error(v-else-if="error")
        template(v-if="error.code")
            Error(:message="$t(error.message || 'Something went wrong!')" :code="error.code")
        template(v-else)
            Error(:message="$t('Something went wrong!')" :code="501")
    .member(v-else)
        tabs(:items="tabs" :active-tab="activeMessagesTabPath" @click="activateTab")
            template(slot="tabbar-buttons")
                // el-tooltip(class="item" effect="dark" :content="$t('Delete')" placement="bottom")
                //     el-button.delete-button(circle type="danger" icon="el-icon-fa-trash-alt far")
                // el-tooltip(class="item" effect="dark" :content="$t('Dismiss')" placement="bottom")
                //     el-button(circle icon="el-icon-fa-times fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save and close')" placement="bottom")
                //     el-button(circle type="primary" icon="el-icon-fa-check fas")
                // el-tooltip(class="item" effect="dark" :content="$t('Save')" placement="bottom")
                //     el-button(circle type="success" icon="el-icon-fa-save fas")
                el-button.delete-button(
                    circle v-if="! loading && isDeletable"
                    type="danger"
                    icon="el-icon-fa-trash-alt far"
                    :loading="deleting"
                    :disabled="isDisabledSubmit && ! deleting"
                    @click="deleteCurrentMember"
                )
                el-button(
                    circle icon="el-icon-fa-times fas"
                    :disabled="isDisabledSubmit"
                    @click="leave"
                )
                el-button(
                    circle v-if="! loading"
                    type="primary"
                    icon="el-icon-fa-check fas"
                    :disabled="isDisabledSubmit && ! savingAndClose"
                    :loading="savingAndClose"
                    @click="submit($event, listRoute)"
                )
                el-button(
                    circle v-if="! loading"
                    type="success"
                    icon="el-icon-fa-save fas"
                    :disabled="isDisabledSubmit && ! saving"
                    :loading="saving"
                    @click="submit"
                )

        el-form(label-position="top" :model="form" :rules="rules" ref="form")
            all-input-fields
            el-card(shadow="always" v-loading="loading")
                router-view.member-form(:key="activeMessagesTabPath" :class="{'loading-panel': loading}")
            .buttons-flex
                .form-buttons
                    el-button(
                        round v-if="!loading && isUpdate && !emailVerified"
                        type="warning"
                        icon="el-icon-fa-paper-plane fas"
                        :loading="resendingEmailVerification"
                        :disabled="isDisabledSubmit && !resendingEmailVerification"
                        @click="resendEmailVerification"
                    ) {{ $t('Resend email verification') }}
                    el-button(
                        round v-if="!loading && isUpdate"
                        icon="el-icon-fa-list fas"
                        :loading="verificationEmailsLoading"
                        @click="showVerificationEmails"
                    ) {{ $t('Verification emails') }}
                .form-buttons
                    el-button(
                        round v-if="! loading"
                        icon="el-icon-fa-times fas"
                        :disabled="isDisabledSubmit"
                        @click="leave"
                    ) {{ $t('Dismiss') }}
                    el-button(
                        round v-if="! loading"
                        type="primary"
                        icon="el-icon-fa-check fas"
                        :loading="savingAndClose"
                        :disabled="isDisabledSubmit && ! savingAndClose"
                        @click="submit($event, listRoute)"
                    ) {{ $t('Save and close') }}
                    el-button(
                        round v-if="! loading"
                        type="success"
                        icon="el-icon-fa-save fas"
                        :loading="saving"
                        :disabled="isDisabledSubmit && ! saving"
                        @click="submit"
                    ) {{ $t('Save') }}

        el-dialog(
            :title="$t('Verification emails')"
            :visible.sync="verificationEmailsVisible"
            width="700px"
        )
            el-table(
                v-if="verificationEmailsLoading || verificationEmails.length"
                :data="verificationEmails"
                v-loading="verificationEmailsLoading"
                stripe
                size="small"
            )
                el-table-column(:label="$t('Status')" prop="status")
                    template(slot-scope="scope")
                        el-tag(:type="getStatusType(scope.row.status)" size="mini") {{ $t(scope.row.status) }}
                el-table-column(:label="$t('Sent')" prop="created_at")
                    template(slot-scope="scope") {{ formatTimestamp(scope.row.created_at) }}
                el-table-column(:label="$t('Delivered')" prop="delivered_at")
                    template(slot-scope="scope") {{ formatTimestamp(scope.row.delivered_at) }}
                el-table-column(:label="$t('Opened')" prop="opened_at")
                    template(slot-scope="scope") {{ formatTimestamp(scope.row.opened_at) }}
                el-table-column(:label="$t('Clicked')" prop="clicked_at")
                    template(slot-scope="scope") {{ formatTimestamp(scope.row.clicked_at) }}
            p(v-if="!verificationEmailsLoading && !verificationEmails.length" style="text-align: center; color: #909399; padding: 40px 0;") {{ $t('No verification emails found') }}
</template>

<i18n>
{
    "en": {
        "delivered": "Delivered",
        "bounced_permanent": "Hard Bounce",
        "bounced_temporary": "Soft Bounce",
        "complained": "Complained",
        "pending": "Pending"
    },
    "de": {
        "Dependencies could not be fetched.": "Abhängigkeiten konnten nicht abgerufen werden.",
        "Person could not be fetched.": "Person konnte nicht gefunden werden.",
        "Person could not be deleted.": "Person konnte nicht gelöscht werden.",
        "Person deleted successfully!": "Person erfolgreich gelöscht!",
        "Person could not be saved.": "Person konnte nicht gespeichert werden.",
        "Email already in use": "E-Mail-Adresse bereits vergeben",
        "Another person with this email address already exists.": "Es existiert bereits eine Person mit dieser E-Mail-Adresse.",
        "Person saved successfully!": "Person erfolgreich gespeichert!",
        "Person Not Found": "Person nicht gefunden",
        "Person": "Person",
        "Addresses": "Adressen",
        "Customer": "Kunde",
        "Orders": "Bestellungen",
        "Documents": "Dokumente",
        "Messages": "Nachrichten",
        "Tags": "Tags",
        "Tag": "Tag",
        "Resend email verification": "E-Mail-Verifizierung erneut senden",
        "Email verification sent successfully": "E-Mail-Verifizierung erfolgreich gesendet",
        "Error sending email verification": "Fehler beim Senden der E-Mail-Verifizierung",
        "Verification emails": "Verifizierungs-E-Mails",
        "No verification emails found": "Keine Verifizierungs-E-Mails gefunden",
        "Sent": "Gesendet",
        "Delivered": "Zugestellt",
        "Opened": "Geöffnet",
        "Clicked": "Geklickt",
        "Status": "Status",
        "yyyy-MM-dd": "dd.MM.yyyy",
        "delivered": "Zugestellt",
        "bounced_permanent": "Dauerhaft abgewiesen",
        "bounced_temporary": "Vorübergehend abgewiesen",
        "complained": "Beschwerde",
        "pending": "Ausstehend"
    }
}
</i18n>

<script>
import _ from 'lodash';
import { timestamp2date } from '@/filters';
import { adminClient as apolloClient } from '@/store/apollo';
import { useSetupStore, useRestrictedAreaMemberStore } from '@/stores';
import { checkRestrictions } from '@/helpers';

import router from '@/router';

import Tabs from '@/components/Tabs';
import Error from '@/components/Error';

// validate all fields, regardless if the corresponding component is mounted or not
import AllInputFields from './AllInputFields';

export default {
    name: 'Member',
    data() {
        return {
            listRoute: { name: 'member-list' },
            error: false,
            pathNotValid: false,
            loading: false,
            saving: false,
            savingAndClose: false,
            deleting: false,
            resendingEmailVerification: false,
            verificationEmailsVisible: false,
        };
    },
    components: {
        Tabs,
        Error,
        AllInputFields
    },
    watch: {
        activeCms(cms) {
            const reload = _.get(cms, 'reloadComponents', true);
            if (reload) {
                this.setInitializedFlag(false);
                this.initialize();
            }
        }
    },
    computed: {
        // The Messages tab route carries a :conversationId (/member/:id/messages/:id) so
        // an open conversation survives reload. Collapse it to the tab base so the tab
        // stays highlighted + its view stays mounted while switching conversations.
        activeMessagesTabPath() {
            const match = this.$route.path.match(/^(\/member\/\d+\/messages)(\/|$)/);
            return match ? match[1] : this.$route.path;
        },
        enabled() {
            return this.enabledExtensions.includes('restricted-area') || this.enabledExtensions.includes('shop');
        },
        id() {
            return _.get(this.form, 'id', false);
        },
        isDeletable() {
            return !!this.id;
        },
        isDisabledSubmit() {
            return this.saving || this.savingAndClose || this.deleting;
        },
        tabs() {
            const id = this.$route.params.id;

            const firstName = _.get(this.form, 'first_name');
            const lastName = _.get(this.form, 'last_name');

            let name = this.$t('Person');
            if (firstName || lastName) {
                name = _.trim(`${firstName} ${lastName}`);
            }

            let tabs = [
                {
                    name,
                    path: `/member/${id}/main`,
                    icon: {
                        name: 'user',
                        group: 'fas'
                    }
                },
                // {
                //     name: this.$t('Addresses'),
                //     path: `/member/${id}/addresses`,
                //     icon: {
                //         name: 'map-marker-alt',
                //         group: 'fas'
                //     }
                // },
                // {
                //     name: this.$t('Tags'),
                //     path: `/member/${id}/tags`,
                //     icon: {
                //         name: 'user-tag',
                //         group: 'fas'
                //     }
                // }
            ];

            if (this.enabledExtensions && this.enabledExtensions.includes('shop')) {
                tabs.push({
                    name: this.$t('Customer'),
                    path: `/member/${id}/customer`,
                    icon: {
                        name: 'id-card',
                        group: 'fas'
                    }
                });

                tabs.push({
                    name: this.$t('Orders'),
                    path: `/member/${id}/purchases`,
                    icon: {
                        name: 'shopping-cart',
                        group: 'fas'
                    }
                });
            }

            // TODO: find a better solution
            // currently the document upload needs an existing member
            if (this.form.id && !this.form.id.startsWith('new')) {
                tabs.push({
                    name: this.$t('Documents'),
                    path: `/member/${id}/documents`,
                    icon: {
                        name: 'file-pdf',
                        group: 'fas'
                    }
                });
            }

            // Customer Communication — message history with this member.
            if (this.enabledExtensions && this.enabledExtensions.includes('communication')
                && checkRestrictions(['ex:comm', 'ex:comm:messages'])
                && this.form.id && !this.form.id.startsWith('new')) {
                tabs.push({
                    name: this.$t('Messages'),
                    path: `/member/${id}/messages`,
                    icon: {
                        name: 'comments',
                        group: 'far'
                    }
                });
            }

            return tabs;
        },
        activeCms() {
            return useSetupStore().activeCms;
        },
        enabledExtensions() {
            return useSetupStore().enabledExtensions;
        },
        setupStore() {
            return useSetupStore();
        },
        memberStore() {
            return useRestrictedAreaMemberStore();
        },
        form() {
            return this.memberStore.form;
        },
        options() {
            return this.memberStore.options;
        },
        initialized() {
            return this.memberStore.formInitialized;
        },
        validateOnEnter() {
            return this.memberStore.formValidateOnEnter;
        },
        rules() {
            return this.memberStore.rules;
        },
        isUpdate() {
            return !!_.get(this.form, 'id') && !String(_.get(this.form, 'id', '')).startsWith('new');
        },
        emailVerified() {
            return _.get(this.form, 'emailVerified', true);
        },
        verificationEmails() {
            return this.memberStore.verificationEmails;
        },
        verificationEmailsLoading() {
            return this.memberStore.verificationEmailsLoading;
        },
    },
    methods: {
        initialize() {
            if (!this.enabled) {
                this.setInitializedFlag(true);
                return;
            }

            if (this.initialized !== true) {
                this.setInitializedFlag(true);

                let dependencies = [];
                // Newsletter subscription topics are CMS-scoped, not shop-scoped, so
                // fetch them whenever the newsletter extension is enabled — independent
                // of whether the CMS has a shop (e.g. event/seminar sites have none).
                if (this.enabledExtensions.includes('newsletter')) {
                    dependencies.push(this.fetchSubscriptionTopicOptions(this.activeCms.id))
                }
                if (this.activeCms.shop && this.activeCms.shop.id) {
                    dependencies.push(this.fetchCustomerGroupOptions(this.activeCms.shop.id))
                    dependencies.push(this.fetchTaxOptions(this.activeCms.shop.id))
                    dependencies.push(this.fetchTagOptions(this.activeCms.id))
                }
                const fetchDependencies = () => Promise.all(dependencies);

                this.error = false;
                this.loading = true;

                const handleDependencyError = err => {
                    const { graphQLErrors } = err

                    let code = 501;
                    let message = 'An error occurred!';

                    if (graphQLErrors) {
                        code = _.get(graphQLErrors, '0.code') || code;
                        message = _.get(graphQLErrors, '0.message') || message;
                    }

                    let notify = true;
                    switch (code) {
                        case 401:
                            notify = false;
                            this.error = { code, message: 'You are not authorized' };
                            break;
                        case 403:
                            notify = false;
                            this.error = { code, message: 'You are not allowed to be here' };
                            break;
                        // case 404:
                        //     break;
                        default:
                            this.error = true;
                            break;
                    }

                    if (notify) {
                        this.$notify.error({
                            title: this.$t(message),
                            message: this.$t('Dependencies could not be fetched.'),
                            iconClass: 'fas el-icon-fa-times',
                            position: 'bottom-left',
                            customClass: 'dark',
                            duration: 8000
                        });
                    }

                    this.loading = false;

                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);
                }

                if (this.$route.params.id === 'new') {
                    fetchDependencies()
                        .then(() => {
                            this.memberStore.reset();
                            // this.memberStore.resetRules()
                        })
                        .catch(handleDependencyError)
                        .finally(() => {
                            this.loading = false;
                        });
                } else if (!isNaN(this.$route.params.id)) {
                    this.fetchMember(this.$route.params.id)
                        .then(() => {
                            // store.commit('ext_restrictedArea_member/resetUI')

                            this.loading = false;

                            const memberID = this.form.id;
                            const filter = {
                                key: 'member',
                                match: memberID
                            };
                            this.defineMemberFilesFilterValue({ key: 'member', value: filter });

                            dependencies.push(this.fetchMemberFilesPaginated({ scope: 'ex', type: 'rstrct_member_file' })
                                .finally(() => this.updateLoadingFiles(false)))

                            // fetch options for dropdowns
                            fetchDependencies()
                                .then(() => {
                                    this.memberStore.resetRules();
                                    // this.memberStore.resetUI()
                                })
                                .catch(handleDependencyError)
                        })
                        .catch(err => {
                            const { graphQLErrors } = err

                            let code = 501;
                            let message = 'An error occurred!';

                            if (graphQLErrors) {
                                code = _.get(graphQLErrors, '0.code') || code;
                                message = _.get(graphQLErrors, '0.message') || message;
                            } else {
                                this.error = true;
                            }

                            switch (code) {
                                case 401:
                                    this.error = { code, message: 'You are not authorized' };
                                    break;
                                case 403:
                                    this.error = { code, message: 'You are not allowed to be here' };
                                    break;
                                case 404:
                                    this.error = { code, message: 'Person Not Found' };
                                    break;
                                default:
                                    this.$notify.error({
                                        title: this.$t('An error occurred!'),
                                        message: this.$t('Person could not be fetched.'),
                                        iconClass: 'fas el-icon-fa-times',
                                        position: 'bottom-left',
                                        customClass: 'dark',
                                        duration: 8000
                                    });
                                    break;
                            }

                            this.loading = false;

                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);
                        });
                } else {
                    this.loading = true;
                    this.pathNotValid = true;
                }
            } else {
                if (this.validateOnEnter === true) {
                    setTimeout(() => {
                        this.$refs.form.validate(() => {
                            // do nothing
                            // callback function is required :(
                        });
                    }, 100);
                }
            }
        },
        deleteCurrentMember() {
            this.deleting = true;
            this.delete(this.id)
                .then(() => {
                    // this.deleting = false

                    router.push(this.listRoute);

                    this.$notify.success({
                        title: this.$t('Person deleted successfully!'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(err => {
                    /* eslint no-console: ["error", { allow: ["error"] }] */
                    console.error(err);

                    this.deleting = false;

                    this.$notify.error({
                        title: this.$t('An error occurred!'),
                        message: this.$t('Person could not be deleted.'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                });
        },
        submit(event, redirect = false) {
            this.$refs.form.validate((valid, errors) => {
                if (valid) {
                    if (redirect) this.savingAndClose = true;
                    else this.saving = true;

                    let save = this.create;
                    if (this.id) save = this.update;

                    save(this.form)
                        .then(async (member) => {
                            await apolloClient.clearStore();
                            this.updateLoadingFiles(true)

                            this.fetchMemberFilesPaginated({ scope: 'ex', type: 'rstrct_member_file' })
                                .finally(() => this.updateLoadingFiles(false))

                            this.$notify.success({
                                title: this.$t('Person saved successfully!'),
                                iconClass: 'fas el-icon-fa-check',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });

                            if (redirect) {
                                router.push(redirect);
                            } else {
                                this.memberStore.resetRules();
                                if (this.$route.params.id === 'new') {
                                    const route = router.currentRoute
                                    route.params.id = member.id
                                    router.replace(route)
                                }
                            }
                        })
                        .catch(err => {
                            /* eslint no-console: ["error", { allow: ["error"] }] */
                            console.error(err);

                            const graphqlMessage = _.get(err, 'graphQLErrors[0].message', '');
                            const isEmailCollision = graphqlMessage.toLowerCase().includes('email collides');

                            const mainTabPath = `/member/${this.$route.params.id}/main`;
                            if (isEmailCollision && this.$route.path !== mainTabPath) {
                                this.activateTab({ path: mainTabPath });
                            }

                            this.$notify.error({
                                title: this.$t(isEmailCollision ? 'Email already in use' : 'An error occurred!'),
                                message: this.$t(isEmailCollision
                                    ? 'Another person with this email address already exists.'
                                    : 'Person could not be saved.'),
                                iconClass: 'fas el-icon-fa-times',
                                position: 'bottom-left',
                                customClass: 'dark',
                                duration: 8000
                            });
                        })
                        .finally(() => {
                            if (redirect) this.savingAndClose = false;
                            else this.saving = false;
                        });
                } else {
                    this.setValidateOnEnterFlag(true);

                    // check the invalid fields
                    // and go to the corresponding tab
                    // or open the corresponding closed area
                    // TODO: scroll to invalid field

                    let invalidTabs = [];
                    _.each(errors, (error, path) => {
                        if (_.indexOf(['gender', 'first_name', 'last_name', 'email', 'password'], path) >= 0) {
                            invalidTabs.push(`/member/${this.$route.params.id}/main`);
                        }
                        if (_.startsWith(path, 'addresses.')) {
                            invalidTabs.push(`/member/${this.$route.params.id}/addresses`);
                        }
                        if (_.startsWith(path, 'customer.')) {
                            invalidTabs.push(`/member/${this.$route.params.id}/customer`);
                        }
                    });

                    invalidTabs = _.uniq(invalidTabs);

                    // check if the current tab
                    // is present in invalidTabs
                    // if not, go to next (first) invalid tab

                    const match = _.indexOf(invalidTabs, this.$route.fullPath);

                    // let switchTab = false;
                    if (match < 0) {
                        invalidTabs.every(invalidTab => {
                            if (invalidTab && this.activeTab !== invalidTab) {
                                const tab = _.find(this.tabs, { path: invalidTab });
                                if (tab) {
                                    this.activateTab(tab)
                                        .then(this.$refs.form.validate)

                                    // break loop after the first tab has been activated
                                    return false;
                                }
                            }
                        });
                    }

                    // // triger the validation again
                    // // so the previously hidden fields will get the errors
                    // // ---
                    // // does not work if the component has been destroyed
                    // // in the meantime (f.a. by switching tabs)
                    // if (switchTab === false) {
                    //     const form = this.$refs.form
                    //     setTimeout(() => {
                    //         form.validate(() => {
                    //             // do nothing
                    //             // callback function is required :(
                    //         })
                    //     }, 1000);
                    // }

                    this.$notify.warning({
                        title: this.$t('Form is not valid!'),
                        message: this.$t('Correct your input and submit again.'),
                        iconClass: 'fas el-icon-fa-exclamation-circle',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                }
            });
        },
        leave() {
            router.push(this.listRoute);
        },
        setInitializedFlag(value) {
            this.memberStore.setFormInitialized(value);
        },
        setValidateOnEnterFlag(value) {
            this.memberStore.setFormValidateOnEnter(value);
        },
        defineMemberFilesFilterValue(payload) {
            this.memberStore.defineMemberFilesFilterValue(payload);
        },
        updateLoadingFiles(value) {
            this.memberStore.updateLoadingFiles(value);
        },
        activateTab(item) {
            return this.setupStore.activateTab(item);
        },
        fetchMember(id) {
            return this.memberStore.fetchMember(id);
        },
        fetchSubscriptionTopicOptions(cmsId) {
            return this.memberStore.fetchSubscriptionTopicOptions(cmsId);
        },
        fetchMemberFilesPaginated(payload) {
            return this.memberStore.fetchMemberFilesPaginated(payload);
        },
        fetchCustomerGroupOptions(shopId) {
            return this.memberStore.fetchCustomerGroupOptions(shopId);
        },
        fetchTaxOptions(shopId) {
            return this.memberStore.fetchTaxOptions(shopId);
        },
        fetchTagOptions(cmsId) {
            return this.memberStore.fetchTagOptions(cmsId);
        },
        create(member) {
            return this.memberStore.create(member);
        },
        update(member) {
            return this.memberStore.update(member);
        },
        delete(id) {
            return this.memberStore.delete(id);
        },
        showVerificationEmails() {
            this.verificationEmailsVisible = true;
            this.memberStore.fetchVerificationEmails();
        },
        getStatusType(status) {
            var statusTypes = {
                delivered: 'success',
                bounced_permanent: 'danger',
                bounced_temporary: 'warning',
                complained: 'danger',
                pending: 'info',
            };
            return statusTypes[status] || 'info';
        },
        formatTimestamp(value) {
            if (!value) return '';
            return timestamp2date(value, this.$t('yyyy-MM-dd') + ', HH:mm');
        },
        resendEmailVerification() {
            this.resendingEmailVerification = true;
            this.memberStore.resendEmailVerification()
                .then(() => {
                    this.$notify.success({
                        title: this.$t('Email verification sent successfully'),
                        iconClass: 'fas el-icon-fa-check',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .catch(() => {
                    this.$notify.error({
                        title: this.$t('Error sending email verification'),
                        iconClass: 'fas el-icon-fa-times',
                        position: 'bottom-left',
                        customClass: 'dark',
                        duration: 8000
                    });
                })
                .finally(() => {
                    this.resendingEmailVerification = false;
                });
        }
    },
    mounted() {
        this.initialize();
    },
    beforeRouteEnter(to, from, next) {
        // redirect if necessary
        const id = _.get(to, 'params.id') || 'new';

        if (to.name === 'member-form') {
            next({ name: 'member-main', params: { id } });
        } else {
            next();
        }
    },
    beforeRouteLeave(to, from, next) {
        next();

        setTimeout(() => {
            this.memberStore.reset();
            this.memberStore.resetUI();
            this.$nextTick(() => this.memberStore.resetRules());
        }, 300);
    },
    destroyed() {
        // console.log('destroyed');
        // geht nicht .. leert das Formular bei klick auf anderen Reiter
        // store.dispatch('ext_restrictedArea_member/reset')
    }
};
</script>

<style lang="sass" scoped>
.member::v-deep
    .el-card__body
        padding: 0
        & > section
            padding: 20px
.el-form-item.switch
    argin-bottom: 0
    min-height: 34px
    display: flex
    align-items: center
</style>
